var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-stat-card",class:_vm.cardClasses},[_c('h3',[_vm._v(_vm._s(_vm.config.title))]),_c('p',[_vm._v("Chart card coming soon...")])])}
var staticRenderFns = []

export { render, staticRenderFns }